export const NAME = 'user';

export const UserRoles = {
  SUPERUSER: 'superuser',
  SALESMANAGER: 'salesmanager',
  REGIONMANAGER: 'regionmanager',
  TEAMLEADER: 'teamlead',
  SELLER: 'user',
  ASSISTANT: 'assistant',
};


// WEBPACK FOOTER //
// ./src/modules/user/user.constants.js